import { render, staticRenderFns } from "./conservationClock.vue?vue&type=template&id=cb1379a8&"
import script from "./conservationClock.vue?vue&type=script&lang=js&"
export * from "./conservationClock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports